import { render, staticRenderFns } from "./ImageWrapper.vue?vue&type=template&id=d7548dd8"
import script from "./ImageWrapper.vue?vue&type=script&lang=js"
export * from "./ImageWrapper.vue?vue&type=script&lang=js"
import style0 from "./ImageWrapper.vue?vue&type=style&index=0&id=d7548dd8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports